import gql from 'graphql-tag'
import {
  FAVORITES_FRAGMENT,
  COMPARISONS_FRAGMENT,
  CART_FRAGMENT,
  EXTENDED_FAVORITES_FRAGMENT,
  EXTENDED_FAVORITE_LIST_ITEM_FRAGMENT,
  PRODUCT_REFERENCE_FRAGMENT,
} from './fragments.graphql'

export const GET_COMPARISONS = gql`
  query GetComparisons {
    comparisons {
      productLists {
        id
        productListName
        items {
          id
          productErpIdentifier
        }
      }
    }
  }
`
export const GET_FAVORITES = gql`
  query GetFavorites {
    favorites {
      productLists {
        items {
          comment
          id
          productErpIdentifier
        }
        productListName
        productListType
        id
      }
    }
  }
`
export const GET_PRODUCT_RECOMMENDATIONS_FOR_FAVORITES = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}
  query GetProductRecommendationsForFavorites {
    favorites {
      productRecommendations {
        ...ProductReference
      }
    }
  }
`
export const GET_EXTENDED_FAVORITES = gql`
  ${EXTENDED_FAVORITES_FRAGMENT}

  query GetExtendedFavorites($enableFavoritesRecommendations: Boolean = false) {
    favorites {
      ...ExtendedFavorites
    }
  }
`

export const GET_EXTENDED_FAVORITES_NO_RECOMMENDATIONS = gql`
  ${EXTENDED_FAVORITE_LIST_ITEM_FRAGMENT}
  query GetExtendedFavoritesNoRecommendations {
    favorites {
      productLists {
        ...ExtendedFavoriteListItem
      }
    }
  }
`

export const GET_FAVORITES_BY_ID = gql`
  ${EXTENDED_FAVORITE_LIST_ITEM_FRAGMENT}

  query GetFavoritesById($favoriteListId: Int!) {
    favoritesById(favoriteListId: $favoriteListId) {
      ...ExtendedFavoriteListItem
    }
  }
`

export const GET_CART = gql`
  ${CART_FRAGMENT}

  query GetCart($withRequiredEndUserInformation: Boolean = false) {
    cart {
      ...Cart
    }
    suggestedDelivery {
      shippingFeeExcludingVat
      shippingFeeVat
      shippingInsuranceFeeExcludingVat
      shippingInsuranceFeeVat
    }
  }
`
export const GET_CUSTOMER_PRODUCT_LISTS = gql`
  ${FAVORITES_FRAGMENT}
  ${COMPARISONS_FRAGMENT}

  query GetCustomerProductLists {
    comparisons {
      ...Comparisons
    }

    favorites {
      ...Favorites
    }
  }
`
